/**
 * @generated SignedSource<<9fb8aab95953d29c1a66c3ea902ca5b0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ServiceGroupSelect_data$data = {
  readonly allServiceGroups: ReadonlyArray<{
    readonly allServices: ReadonlyArray<{
      readonly id: string;
      readonly name: string;
    }>;
    readonly id: string;
    readonly name: string;
  }>;
  readonly " $fragmentType": "ServiceGroupSelect_data";
};
export type ServiceGroupSelect_data$key = {
  readonly " $data"?: ServiceGroupSelect_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"ServiceGroupSelect_data">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ServiceGroupSelect_data",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ServiceGroup",
      "kind": "LinkedField",
      "name": "allServiceGroups",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "Service",
          "kind": "LinkedField",
          "name": "allServices",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "01a0d651b2e146e317d6ab28e7632395";

export default node;
